export const AUTH_LOGIN = "api/user/signin";
export const AUTH_LOGOUT = "auth/Logout";
export const AUTH_RESET = "auth/Reset";
export const AUTH_SIGNUP = "api/user/signup";
export const AUTH_FULL_SIGNUP = "api/user/profile";
export const RESET_PASS = "/api/user/password/change";
export const VERIFY_RESET_PASS = "auth/TokenVerifcation";
export const SET_NEW_PASSWORD = "auth/SetPassword";
export const DELETE_ACCOUNT = "auth/DeleteAccount";
export const FETCH_NOTIFICATION = "auth/FetchNotification";
export const UPDATE_NOTIFICATION = "auth/updateNotification";
export const FETCH_CURRENCIES = "auth/currencies";
export const LANGUAGE_UPDATE = "profile/updateLanguage";